"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports.createType = createType;
exports.deleteType = deleteType;
exports.deleteVehicle = deleteVehicle;
exports.edit = edit;
exports.editType = editType;
exports.list = list;
exports.listType = listType;
exports.vehiclesWatcher = vehiclesWatcher;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _helpers = require("@qwkin/helpers");
var _variables = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables2 = require("../variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(vehiclesWatcher);
function list(_ref) {
  var payload = _ref.payload,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? _helpers.identity : _ref$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.VehiclesService.list, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_VEHICLES_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context.next = 17;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_VEHICLES_FAIL,
            payload: _response
          });
        case 14:
          _context.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 16:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  })();
}
function listType(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.VehiclesService.listType, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables2.LIST_VEHICLE_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          callback();
          _context2.next = 17;
          break;
        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 14;
          return (0, _effects.put)({
            type: _variables2.LIST_VEHICLE_TYPE_FAIL,
            payload: _response2
          });
        case 14:
          _context2.next = 16;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 16:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 9]]);
  })();
}
function create(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.VehiclesService.create, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables2.CREATE_VEHICLE_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Vehicle created with success'
            }
          });
        case 8:
          callback();
          _context3.next = 19;
          break;
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 16;
          return (0, _effects.put)({
            type: _variables2.CREATE_VEHICLE_FAIL,
            payload: _response3
          });
        case 16:
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 18:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 19:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  })();
}
function createType(_ref7) {
  var payload = _ref7.payload,
    _ref7$callback = _ref7.callback,
    callback = _ref7$callback === void 0 ? _helpers.identity : _ref7$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.VehiclesService.createType, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables2.CREATE_VEHICLE_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Vehicle type created with success'
            }
          });
        case 8:
          callback();
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables2.CREATE_VEHICLE_TYPE_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function edit(_ref9) {
  var payload = _ref9.payload,
    _ref9$callback = _ref9.callback,
    callback = _ref9$callback === void 0 ? _helpers.identity : _ref9$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _err$response$data, _err$response, _err$response$data2, _err$response2;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.VehiclesService.edit, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables2.EDIT_VEHICLE_SUCCESS,
            payload: response
          });
        case 6:
          _context5.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Vehicle  edited with success'
            }
          });
        case 8:
          callback();
          _context5.next = 18;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 15;
          return (0, _effects.put)({
            type: _variables2.EDIT_VEHICLE_FAIL,
            payload: _context5.t0.response
          });
        case 15:
          _context5.next = 17;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_err$response$data = (_err$response = _context5.t0.response) === null || _err$response === void 0 ? void 0 : _err$response.data) !== null && _err$response$data !== void 0 ? _err$response$data : {})
            }
          });
        case 17:
          (0, _utils.logErr)((_err$response$data2 = (_err$response2 = _context5.t0.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) !== null && _err$response$data2 !== void 0 ? _err$response$data2 : {});
        case 18:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 11]]);
  })();
}
function editType(_ref10) {
  var payload = _ref10.payload,
    _ref10$callback = _ref10.callback,
    callback = _ref10$callback === void 0 ? _helpers.identity : _ref10$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _err$response$data3, _err$response3, _err$response$data4, _err$response4;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.VehiclesService.editType, payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables2.EDIT_VEHICLE_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Vehicle type edited with success'
            }
          });
        case 8:
          callback();
          _context6.next = 18;
          break;
        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 15;
          return (0, _effects.put)({
            type: _variables2.EDIT_VEHICLE_TYPE_FAIL,
            payload: _context6.t0.response
          });
        case 15:
          _context6.next = 17;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_err$response$data3 = (_err$response3 = _context6.t0.response) === null || _err$response3 === void 0 ? void 0 : _err$response3.data) !== null && _err$response$data3 !== void 0 ? _err$response$data3 : {})
            }
          });
        case 17:
          (0, _utils.logErr)((_err$response$data4 = (_err$response4 = _context6.t0.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.data) !== null && _err$response$data4 !== void 0 ? _err$response$data4 : {});
        case 18:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 11]]);
  })();
}
function deleteType(_ref11) {
  var payload = _ref11.payload,
    _ref11$callback = _ref11.callback,
    callback = _ref11$callback === void 0 ? _helpers.identity : _ref11$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
    var response, _err$response$data5, _err$response5, _err$response$data6, _err$response6;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.VehiclesService.deleteType, payload);
        case 3:
          response = _context7.sent;
          _context7.next = 6;
          return (0, _effects.put)({
            type: _variables2.DELETE_VEHICLE_TYPE_SUCCESS,
            payload: response
          });
        case 6:
          _context7.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Vehicle type deleted with success'
            }
          });
        case 8:
          callback();
          _context7.next = 18;
          break;
        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 15;
          return (0, _effects.put)({
            type: _variables2.DELETE_VEHICLE_TYPE_FAIL,
            payload: _context7.t0.response
          });
        case 15:
          _context7.next = 17;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_err$response$data5 = (_err$response5 = _context7.t0.response) === null || _err$response5 === void 0 ? void 0 : _err$response5.data) !== null && _err$response$data5 !== void 0 ? _err$response$data5 : {})
            }
          });
        case 17:
          (0, _utils.logErr)((_err$response$data6 = (_err$response6 = _context7.t0.response) === null || _err$response6 === void 0 ? void 0 : _err$response6.data) !== null && _err$response$data6 !== void 0 ? _err$response$data6 : {});
        case 18:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 11]]);
  })();
}
function deleteVehicle(_ref12) {
  var payload = _ref12.payload,
    _ref12$callback = _ref12.callback,
    callback = _ref12$callback === void 0 ? _helpers.identity : _ref12$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.VehiclesService["delete"], payload);
        case 3:
          response = _context8.sent;
          _context8.next = 6;
          return (0, _effects.put)({
            type: _variables2.DELETE_VEHICLE_SUCCESS,
            payload: response
          });
        case 6:
          _context8.next = 8;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Vehicle deleted with success'
            }
          });
        case 8:
          callback();
          _context8.next = 19;
          break;
        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](0);
          _response5 = _context8.t0.response;
          _context8.next = 16;
          return (0, _effects.put)({
            type: _variables2.DELETE_VEHICLE_FAIL,
            payload: _response5
          });
        case 16:
          _context8.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 18:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 19:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 11]]);
  })();
}
function vehiclesWatcher() {
  return _regenerator["default"].wrap(function vehiclesWatcher$(_context9) {
    while (1) switch (_context9.prev = _context9.next) {
      case 0:
        _context9.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables2.LIST_VEHICLES_REQUEST, list), (0, _effects.takeLatest)(_variables2.LIST_VEHICLE_TYPE_REQUEST, listType), (0, _effects.takeLatest)(_variables2.CREATE_VEHICLE_REQUEST, create), (0, _effects.takeLatest)(_variables2.CREATE_VEHICLE_TYPE_REQUEST, createType), (0, _effects.takeLatest)(_variables2.DELETE_VEHICLE_TYPE_REQUEST, deleteType), (0, _effects.takeLatest)(_variables2.DELETE_VEHICLE_REQUEST, deleteVehicle), (0, _effects.takeLatest)(_variables2.EDIT_VEHICLE_TYPE_REQUEST, editType), (0, _effects.takeLatest)(_variables2.EDIT_VEHICLE_REQUEST, edit)]);
      case 2:
      case "end":
        return _context9.stop();
    }
  }, _marked);
}